import { BigBashEvent } from "@/types/types";
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EventFormSectionStyles } from "./SectionStyles";

@customElement("notes-section")
class NotesSection extends LitElement {
	static readonly styles = [EventFormSectionStyles];

	@property({ type: Object }) values: Partial<BigBashEvent> = {};

	render() {
		return html`
            <div class="form-section">
                <p class="form-section-title">📝 Notizen und Besonderheiten</p>
                <basic-textarea
                    helperText="Diese Notizen sind nur für Sie als Moderator sichtbar"
                    label="Interne Notizen"
                    name="notes"
                    placeholder="Besonderheiten, Wünsche oder wichtige Hinweise für dieses Event..."
                    rows="4"
					value="${this.values?.notes || ''}"
                ></basic-textarea>
            </div>
        `;
	}
}

export default NotesSection;